import type { Editor } from "grapesjs";
import { panelConfigOptions } from "./configs/panel-config-options";
import { panelConfigViews } from "./configs/panel-config-views";
import { injectTheme } from "./styles/editor-styles";
import { removePresetBlocks } from "./blocks/remove-preset-blocks";
import { BASIC_INPUTS } from "../../../templates/_shared/inputs/_init";
import { BASIC_MODULES } from "../../../templates/_shared/modules/_init";
import { registerBlocks } from "./blocks/register-blocks";
import { bindCompanyProvider } from "../helpers/company-provider";
import { store } from "../../../../../redux/store";

export async function initEditor(container: HTMLDivElement): Promise<Editor> {
  const grapesjs = (await import("grapesjs")).default;
  const presetWebpage = (await import("grapesjs-preset-webpage")).default;
  bindCompanyProvider(() => store.getState().userState.company ?? null);
  injectTheme();

  const editor = grapesjs.init({
    container,
    height: "100%",
    width: "auto",
    storageManager: false,
    plugins: [presetWebpage],
    pluginsOpts: {
      [presetWebpage as any]: {
        blocksBasicOpts: { flexGrid: 1 },
        formsOpts: true,
        navbarOpts: false,
        countdownOpts: false,
        panelsOpts: false,
      },
    },
    panels: { defaults: [] },
    blockManager: {
      custom: true,
    },

    layerManager: {
      appendTo: ".gjs-layers-container",
    },
    styleManager: {
      appendTo: ".gjs-styles-container",
    },
    traitManager: {
      appendTo: ".gjs-traits-container",
    },
  });

  await waitForCompanies();
  removePresetBlocks(editor);
  registerBlocks(editor, [...BASIC_INPUTS, ...BASIC_MODULES]);

  panelConfigOptions(editor);
  panelConfigViews(editor);
  return editor;
}

async function waitForCompanies(): Promise<void> {
  return new Promise((resolve) => {
    if (store.getState().userState.companies?.length) return resolve();
    const unsub = store.subscribe(() => {
      if (store.getState().userState.companies?.length) {
        unsub();
        resolve();
      }
    });
  });
}
